import * as customersApi from '../api';

import {
  IGetCustomerFullNameResponseData,
  IGetCustomerLinkedAccountsResponseData,
  IGetCustomerProfileResponseData,
  IGetCustomerResponseData,
  IGetDemandDashboardResponseData,
  IGetOtherCustomerProfileResponseData,
  IGetSupplierDashboardResponseData,
  IUpdateCustomerProfileRequestData,
  IUpdateCustomerRequestData,
  IUpdateCustomerResponseData,
  IUploadAvatarResponse,
} from '../types';

export const getCustomerFullName = async (
  customerId: string
): Promise<IGetCustomerFullNameResponseData> =>
  customersApi.getCustomerFullName(customerId);

export const getCustomer = async (
  customerId?: string
): Promise<IGetCustomerResponseData> => customersApi.getCustomer(customerId);

export const updateCustomer = async (
  data: IUpdateCustomerRequestData
): Promise<IUpdateCustomerResponseData> => customersApi.updateCustomer(data);

export const getCustomerProfileDetails =
  async (): Promise<IGetCustomerProfileResponseData> =>
    customersApi.getCustomerProfileDetails();

export const getOtherCustomerProfile = async (
  customerId: string
): Promise<IGetOtherCustomerProfileResponseData> =>
  customersApi.getOtherCustomerProfile(customerId);

export const updateCustomerProfileDetails = async (
  data: IUpdateCustomerProfileRequestData
): Promise<void> => customersApi.updateCustomerProfileDetails(data);

export const customerProfileDetailsUpdated = async (): Promise<void> =>
  customersApi.customerProfileDetailsUpdated();

export const getDemandDashboard =
  async (): Promise<IGetDemandDashboardResponseData> =>
    customersApi.getDemandDashboard();

export const getSupplierDashboard =
  async (): Promise<IGetSupplierDashboardResponseData> =>
    customersApi.getSupplierDashboard();

export const getCustomerLinkedAccounts = async (
  customerId: string
): Promise<IGetCustomerLinkedAccountsResponseData> =>
  customersApi.getCustomerLinkedAccounts(customerId);

export const uploadCustomerAvatar = async (
  formData: FormData
): Promise<IUploadAvatarResponse> =>
  customersApi.uploadCustomerAvatar(formData);

export const deleteCustomerAvatar = async (): Promise<void> =>
  customersApi.deleteCustomerAvatar();
